<div class="page-wrapper">

  <div class="page-header">
    <div class="page-title">
      <svg class="page-title__icon" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 8.5a2 2 0 100-4 2 2 0 000 4ZM2 14v-1a3 3 0 013-3 3 3 0 013 3v1H2Zm9.5-6a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5ZM8.9 10.6A3.5 3.5 0 0111.5 9.5C13.43 9.5 15 11.07 15 13v1h-4.55c.03-.16.05-.33.05-.5v-1c0-.68-.2-1.3-.55-1.9Z" fill="currentColor"/>
      </svg>
      <h1 class="page-title__text">Users</h1>
    </div>
    <p class="page-title__sub">Everyone with an account, and how they sign in.</p>
  </div>

  @if (totals; as t) {
    <app-admin-totals-card
      [description]="hasFilters ? 'The users matching your filters.' : 'Every account on the platform.'"
      [filterLabel]="totalsFilterLabel"
      [columns]="4"
      [loading]="isLoading"
    >
      <div appTotalsFigure label="Users" info="How many accounts match the current filters." [note]="hasFilters ? 'Matching your filters' : 'Every account'">{{ t.users | number }}</div>
      <div appTotalsFigure label="Confirmed" info="Users who have confirmed their email address. The bar shows their share of all users here." [note]="'of ' + (t.users | number) + ' · ' + (t.confirmedShare | percent)" [progress]="t.confirmedShare">{{ t.confirmed | number }}</div>
      <div appTotalsFigure label="Superadmins" info="Platform staff who can open this superadmin panel." note="Can open this panel">{{ t.superadmins | number }}</div>
      <div appTotalsFigure label="Sign in with SSO" info="Users who sign in through an SSO provider instead of a password." note="The rest use a password">{{ t.sso | number }}</div>
    </app-admin-totals-card>
  } @else if (!hasLoadedOnce) {
    <app-admin-totals-card [skeletonLabels]="['Users', 'Confirmed', 'Superadmins', 'Sign in with SSO']" [columns]="4" />
  }

  <div class="api-card api-card--full" #listCard>
    <div class="admin-filter-bar">
      <div class="admin-filter-bar__search">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="7.25" cy="7.25" r="4.75" stroke="currentColor" stroke-width="1.6"/><path d="M10.75 10.75 14 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
        <input type="text" placeholder="Search by name, email, or organization..." [ngModel]="search" (ngModelChange)="onSearchChange($event)" />
      </div>
      @if (phone) {
        <!-- Phones: the other filters live in a sheet (admin-filters-sheet). -->
        <button type="button" class="admin-filter-bar__filters" (click)="openFilters()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 4h11M4.5 8h7M6.5 12h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
          Filters
          @if (activeFilterCount) {
            <span class="admin-filter-bar__count">{{ activeFilterCount }}</span>
          }
        </button>
      } @else {
        <select class="admin-filter-bar__select" [ngModel]="staffOnly ? 'staff' : 'all'" (ngModelChange)="onStaffOnlyChange($event)">
          <option value="all">All users</option>
          <option value="staff">Staff only</option>
        </select>
      }
    </div>

    @if (isLoading) {
      <div class="admin-table-scroll">
        <table class="billing-table admin-stack admin-stack--users">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Organization</th>
              <th>Sign-in</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            @for (i of [1,2,3,4,5]; track i) {
              <tr>
                <td><app-skeleton width="70%" height="14px"></app-skeleton></td>
                <td><app-skeleton width="80%" height="14px"></app-skeleton></td>
                <td><app-skeleton width="60%" height="14px"></app-skeleton></td>
                <td><app-skeleton width="40px" height="14px"></app-skeleton></td>
                <td><app-skeleton width="60px" height="20px" radius="4px"></app-skeleton></td>
                <td><app-skeleton width="80px" height="14px"></app-skeleton></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else if (rows.length) {
      <div class="admin-table-scroll">
        <table class="billing-table admin-stack admin-stack--users">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Organization</th>
              <th>Sign-in</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.id) {
              <tr>
                <td>
                  {{ row.name }}
                  @if (row.superadmin) {
                    <span class="txn-kind-badge txn-kind-badge--grant">Superadmin</span>
                  }
                </td>
                <td>{{ row.email }}</td>
                <td>
                  @if (orgSlug(row)) {
                    <a [routerLink]="['/admin/organizations', orgSlug(row)]" class="link">{{ orgName(row) }}</a>
                  } @else {
                    {{ orgName(row) }}
                  }
                  @if (orgRole(row)) {
                    <br><span class="billing-table__sub">{{ orgRole(row) }}</span>
                  }
                </td>
                <td>{{ signIn(row) }}</td>
                <td>
                  @if (row.confirmed) {
                    <span class="admin-status--ok">Confirmed</span>
                  } @else {
                    <span class="txn-kind-badge txn-kind-badge--warning">Pending</span>
                  }
                </td>
                <td>{{ row.createdAt | date:'mediumDate' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="table-footer">
        <span>{{ pagination?.total ?? rows.length | number }} user{{ (pagination?.total ?? rows.length) === 1 ? '' : 's' }}</span>
        @if (pagination && pagination.pages > 1) {
          <div class="table-footer__pager">
            <button type="button" class="btn--secondary" [disabled]="page <= 1" (click)="goToPage(page - 1)">Previous</button>
            <span>Page {{ page }} of {{ pagination.pages }}</span>
            <button type="button" class="btn--secondary" [disabled]="page >= pagination.pages" (click)="goToPage(page + 1)">Next</button>
          </div>
        }
      </div>
    } @else {
      <div class="empty-state">
        @if (hasFilters) {
          <p class="empty-state__title">No users match your filters.</p>
          <p class="empty-state__desc">Try a different name or email, or clear the filters.</p>
          <button type="button" class="btn--secondary empty-state__action" (click)="clearFilters()">Clear filters</button>
        } @else {
          <p class="empty-state__title">No users yet.</p>
          <p class="empty-state__desc">Everyone with an account appears here.</p>
        }
      </div>
    }
  </div>

</div>
